export class Const {
    static readonly PROD_ENV: string = "PROD";
    static readonly STORAGE_RECENT_SEARCHES: string = 'asset_recent_searches';
    static readonly STORAGE_AUTH_TOKEN: string = 'auth_token';
    static readonly STORAGE_AUTH_EMAIL: string = 'auth_email';

    static readonly RECENT_SEARCHES_MAX: number = 5;

    static readonly SEARCH_QUERY_LIMIT: number = 25;

    static readonly TRACEABLE_COMPONENT_FACTORY: string = "factory";
    static readonly TRACEABLE_COMPONENT_CURRENT: string = "current";

    static readonly MAX_OFFERING_TREE_LEVEL: number = 2;
}
